import { apiSlice, apiTags } from "src/shared/apiSlice";
import { ProductQueryResult } from "./model/Product";
import productsTransformer from "./model/ProductTransformer";
import { ProductDetail } from "./model/ProductWithVariant";

const productApi = apiSlice.injectEndpoints({
  endpoints: (build) => ({
    getProducts: build.query<ProductQueryResult, number>({
      query: (streamId) => ({
        url: `public/events/${streamId}/products/`,
      }),
      providesTags: (result, error, id) => [apiTags.Products],
      transformResponse: productsTransformer,
    }),
    getProductDetail: build.query<ProductDetail, { url: string }>({
      query: ({ url }) => ({ url }),
      providesTags: (result, error, id) => [apiTags.ProductDetail],
    }),
  }),
});

export const { useGetProductsQuery, useGetProductDetailQuery } = productApi;
